export default "/_next/static/chunks/fonts/HK Grotesk Regular-2be4b5d6f4835d40a714b175fb4b5c19.otf";